import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import I18n from 'i18n-js';

// @ts-ignore lib
import { useRadarProfileData } from '@lootboy/lib/slices/radarUserProfile';

import Image from '~/components/Image';

import config from '~/config';
import { usernameSelector } from '~/redux/selectors/user';
import { RADAR_PATH } from '~/routes/paths';
import { RADAR_EDIT_PATH } from '~/views/RadarView/paths';

import styles from './MenuHeader.module.scss';

export function MenuHeader(): JSX.Element {
  const username = useSelector(usernameSelector);
  const radarData = useRadarProfileData();

  const avatarUrl = radarData?.userData?.avatar?.path;

  return (
    <div className={styles.user}>
      {avatarUrl && (
        <Link
          to={`${RADAR_PATH}${RADAR_EDIT_PATH}`}
          className={styles.link}
        >
          <Image
            alt=""
            src={`${config.STATIC_RESOURCES_BASE_URL}/${avatarUrl}`}
            loading="eager"
            className={styles.avatar}
          />
        </Link>
      )}
      <h3 className={styles.username}>
        {avatarUrl
          ? username
          : I18n.t('MenuView_header', { username: username ?? '' })}
      </h3>
    </div>
  );
}
